@if (isDisplay) {
  <iu-prime-steps
    styleClass="steps-custom"
    [activeIndex]="activeIndex"
    [attr.data-cy-value]="isReadOnly"
    [isIndexNumber]="isIndexNumber"
    [model]="items"
    [preventPrevious]="preventPrevious"
    [readonly]="isReadOnly"
    (activeIndexChange)="changeItem($event)" />
}
